import type { AppTourStep } from '@fordeer/app-tour'

export interface InvoiceVirtualTourStepDefinition {
  align?: InvoiceTourStepAlign
  description: string
  side?: InvoiceTourStepSide
  targetKey: string
  title: string
}

export interface InvoiceVirtualTour {
  id: string
  label: string
  order: number
  slug: string
  stepDefinitions: InvoiceVirtualTourStepDefinition[]
}

export const TEMPLATE_CUSTOMIZATION_TOUR_SLUG = 'customize-invoice-template'
export const CUSTOMIZE_INVOICE_CODE_TOUR_SLUG = 'customize-invoice-code'
export const SETUP_STORE_LOGO_TOUR_SLUG = 'setup-store-logo'

/** Tours that resolve `:themeId` in target routes at launch. */
export const TOURS_REQUIRING_THEME_ID = [
  TEMPLATE_CUSTOMIZATION_TOUR_SLUG,
  CUSTOMIZE_INVOICE_CODE_TOUR_SLUG,
] as const

type PopoverConfig = NonNullable<AppTourStep['popover']>

export type InvoiceTourStepSide = PopoverConfig['side']
export type InvoiceTourStepAlign = PopoverConfig['align']
